module.exports = __webpack_public_path__ + "img/frequency.d6939b7c.svg";